import React, { useState } from 'react';
import { useCompaniesData } from '../../../../../Hooks/TT_ELD/Companies';
import CompaniesTable from './CompaniesTable';
import { Button } from 'antd';
import SearchInput from '../../../../../Utils/SearchInput';
import useRouteQuery from '../../../../../Utils/useRouterQuery';
import { useTagQuerySync } from '../../../../../Utils/useTagQuerySync';

const Companies = () => {
  const [usdotId, setUsdotId] = useRouteQuery('', 'usdotId', (v) => String(v));
  const [uid, setUid] = useRouteQuery('', 'uid', (v) => String(v));
  const [companyName, setCompanyName] = useRouteQuery('', 'companyName', String);

  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      companyName: setCompanyName,
      usdotId: setUsdotId,
      uid: setUid,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event.trim());
    }
  };
  const [skip, setSkip] = useState<string>('1');

  const { data, refetch, isLoading, isFetching } = useCompaniesData(
    companyName,
    usdotId,
    undefined,
    skip,
    '',
    '',
    '',
    uid,
  );

  useTagQuerySync(
    { en_US: 'Companies', zh_CN: '' },
    'companies',
    { companyName, uid, usdotId, skip },
    { companyName: setCompanyName, uid: setUid, usdotId: setUsdotId, skip: setSkip },
  );

  const onChange = (query: any) => {
    setSkip(query.current);
  };
  return (
    <div className="mainPage">
      <SearchInput
        value={companyName}
        placeholder="Search by company"
        onDebounceChange={(event: string) => handleChange(event, 'companyName')}
      />
      <SearchInput
        value={usdotId}
        placeholder="Search by USDOT"
        onDebounceChange={(event: string) => handleChange(event, 'usdotId')}
      />
      <SearchInput
        value={uid}
        placeholder="Search by UID"
        onDebounceChange={(event: string) => handleChange(event, 'uid')}
      />
      <Button
        style={{ float: 'right', marginLeft: '15px' }}
        size={'large'}
        onClick={() => refetch()}
      >
        Refresh
      </Button>
      <CompaniesTable
        companiesData={data?.data}
        total={data?.count}
        onChange={onChange}
        isLoading={isLoading}
        isFetching={isFetching}
        skip={skip}
        refetch={refetch}
      />
    </div>
  );
};

export default Companies;
